import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AppConfig} from './app.config';

import {LocalStorageService} from 'ngx-localstorage';
import {HttpClient} from '@angular/common/http';
import {OnlineStatusService, OnlineStatusType} from 'ngx-online-status';
import {lastValueFrom, take} from 'rxjs';
import {ChatSocket} from './app.module';
import {PromptUpdateService} from './services/prompt-update.service';
import moment from 'moment';
import {MixpanelService} from './services/mix-panel.service';
import {NavigationEnd, Router} from '@angular/router';
import {DashboardService} from './dashboard/dashboard.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'opla-energy-dashboard';

  @HostListener('window:resize')
  onResize() {
    this.appConfig.windowHeight = window.innerHeight;
    const isMobile = window.matchMedia('(max-width: 768px)');
    this.appConfig.isMobile = isMobile.matches;
    this.appConfig.sizeChanged$.next();
  }

  constructor(
    public appConfig: AppConfig,
    public http: HttpClient,
    public localStorageService: LocalStorageService,
    private chatSocket: ChatSocket,
    private onlineStatusService: OnlineStatusService
    ) {

    this.onlineStatusService.status.subscribe(async (status: OnlineStatusType) => {
      if (status === OnlineStatusType.OFFLINE) {
        this.appConfig.openSnackBar('No internet connection');
      } else {
        let lastValue = await lastValueFrom(this.appConfig.appOffline$.pipe(take(1)));
        if (lastValue === true) {
          this.appConfig.openSnackBar('Internet connection restored', true);
        }
      }
      this.appConfig.appOffline$.next(status === OnlineStatusType.OFFLINE);
    });


    if (this.localStorageService.get('isDarkMode') === null) {
      if (moment().hour() >= 7 && moment().hour() <= 19) {
        document.body.classList.remove('dark-mode');
        document.body.classList.add('light-mode');
        this.localStorageService.set('isDarkMode', false);
      } else {
        document.body.classList.remove('light-mode');
        document.body.classList.add('dark-mode');
        this.localStorageService.set('isDarkMode', true);
      }
    } else {
      if (this.appConfig.isDarkMode) {
        document.body.classList.remove('light-mode');
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
        document.body.classList.add('light-mode');
      }
    }

    let root = document.documentElement;
    appConfig.windowHeight = window.innerHeight;
    root.style.setProperty('--window-height', window.innerHeight + 'px');
  }

  ngOnInit() {

    this.appConfig.isChatStreamConnected$.next(false);

    this.chatSocket.on('stream_connected', (e) => {
      this.appConfig.isChatStreamConnected$.next(e);
    });

    this.chatSocket.on('disconnect', (e) => {
      this.appConfig.isChatStreamConnected$.next(false);
    });

    this.chatSocket.on('new_message_counter', (e) => {
      this.appConfig.newMessageCounter$.next(e);
    });

    this.chatSocket.on('last_message_updated', (e) => {
      this.appConfig.lastMessageUpdated$.next(e);
    });

  }

  ngOnDestroy(): void {
  }
}
